import React, { FC } from 'react';
import { sizeGuideViewedEvent } from '../../common/models/TrackingEvents';
import { track } from '../../helpers/tracking/tracking';

export const SizeGuideActivator: FC<{
  department: string;
  margin?: string;
  setSizeGuideVisible: () => void;
}> = ({ department, margin, setSizeGuideVisible }) => {
  return (
    <div className="wrapper">
      <a
        className="link"
        onClick={() => {
          track(sizeGuideViewedEvent, {
            categoryDepartment: {
              department: department.toLowerCase(),
            },
          });
          if (setSizeGuideVisible) {
            setSizeGuideVisible();
          }
        }}
      >
        Size guide
      </a>
      <style jsx>{`
        @media (max-width: 1023px) {
          .wrapper {
            user-select: none;
            outline: none;
            margin: ${margin || '0 13% 0 0'};
          }
        }

        .link {
          font-size: 15px;
          line-height: 20px;
          color: #000000;
          text-decoration: underline;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};
